export class MenuService {
    hasPermission(permission, menuPermissions) {
        return menuPermissions.includes(permission);
    }
    createMenuItem({ id, text, icon, path, permission }, menuPermissions) {
        if (!permission || this.hasPermission(permission, menuPermissions)) {
            return { id, text, icon, path, permission };
        }
        return null;
    }
    createSidebar(menus, menuPermissions) {
        const sidebar = menus
            .map(menu => this.createMenuItem(menu, menuPermissions))
            .filter(menu => menu !== null);
        return sidebar.length > 0 ? sidebar : [];
    }
}
export function GetMenuOrder(menuList, currentItem) {
    if (currentItem === "Home") {
        return 1;
    }
    const sortedMenuList = [...menuList]
        .filter(item => item !== "Home")
        .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
    return sortedMenuList.indexOf(currentItem) + 4; 
}
